import React, { useState, useEffect } from 'react';
import { translate } from 'react-switch-lang';
import { ListingDatatable } from '../../_fragments';
import Form from './Form';
import { employeeSchema as schema } from '../../_validationSchema';
import { employeeAction as actions } from '../../_action/employee.action';
import { employee_model as model } from '../../_model';
import { employeeConstants as constants } from '../../_constants';

import { useSelector } from 'react-redux';

const Employee = (props) => {
  const { t } = props;

  const header = { name: 'Employee', icon: 'cubes' };
  const reducer = useSelector((state) => state.employeeOperation);
  const [item, setItem] = React.useState({});

  const filenameXML = 'employee';
  const menuCode = 'M_ASSET_MODEL';
  const columns = [
    { title: t('Code'), field: 'Code' },
    { title: t('Username'), field: 'Username' },
    { title: t('FirstName'), field: 'FirstName' },
    { title: t('LastName'), field: 'LastName' },
  ];
  let useService = () => {
    return [schema, actions, model, constants];
  };
  const [open, setOpen] = useState(false);
  const [selectedCode, setSelected] = useState('');
  const [type, setFormType] = useState('');
  const [keyTrigger, setTrigger] = useState(false);
  useEffect(() => {
    var isCancelled = false;
    if (!isCancelled) {
      if (open === false) {
        setFormType('');
        setTrigger(!keyTrigger);
      }
    }

    return () => {
      isCancelled = true;
    };
  }, [open]);
  useEffect(() => {
    var isCancelled = false;
    if (!isCancelled) {
      if (reducer.getSuccess) {
        setItem(reducer.data.data.info);
      }
    }
    return () => {
      isCancelled = true;
    };
  }, [reducer]);
  return (
    <>
      <Form
        type={type}
        header={header}
        code={selectedCode}
        open={open}
        setClose={() => setOpen(false)}
        useService={useService}
        reducer={reducer}
        item={item}
      />
      <ListingDatatable
        key={keyTrigger}
        header={header}
        columns={columns}
        filenameXML={filenameXML}
        setSelected={setSelected}
        setFormOpen={setOpen}
        setFormType={setFormType}
        menuCode={menuCode}
      />
    </>
  );
};

export default translate(Employee);
